import { DeviceType } from 'editor/src/store/app/types';

const MAX_MOBILE_DEVICE_RESOLUTION = 800;

export default function getCustomerDeviceType() {
  return window.innerWidth <= MAX_MOBILE_DEVICE_RESOLUTION ? DeviceType.Mobile : DeviceType.Desktop;
}
